//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.SheetMetal.js";
import "../Features/Features.SheetMetal.SheetmetalBaseBuilder.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
let d=[[[1,"Angle",0,"Expression",0],[0,"AngleLawType",1,0],[1,"Edges",0,"ScCollector",0],[1,"EndAngle",0,"Expression",0],[1,"EndLength",0,"Expression",0],[1,"Length",0,"Expression",0],[0,"LengthLawType",1,0],[0,"LengthReference",1,0],[1,"NeutralFactor",0,"Expression",0],[0,"PunchVector",1,"Direction",0],[1,"Radius",0,"Expression",0],[0,"ReverseDirection",1,0],[1,"StartAngle",0,"Expression",0],[1,"StartLength",0,"Expression",0],[0,"Type",1,0]],[],[]];
SPLM.Features.SheetMetal.VariationalFlangeBuilder = class extends SPLM.Features.SheetMetal.SheetmetalBaseBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SheetMetal.VariationalFlangeBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.SheetMetal.VariationalFlangeBuilder.Types = Object.freeze({
    "NormalToFace" : "NormalToFace", "AlongPunchVector" : "AlongPunchVector"});

SPLM.Features.SheetMetal.VariationalFlangeBuilder.LengthReferences = Object.freeze({
    "Inside" : "Inside", "Outside" : "Outside", "Web" : "Web", "Tangent" : "Tangent"});

SPLM.Features.SheetMetal.VariationalFlangeBuilder.LawTypes = Object.freeze({
    "Constant" : "Constant", "Linear" : "Linear"});

export default SPLM;